module.exports = __webpack_public_path__ + "static/media/caffe-milano-cover.1a79b9a1.jpg";